import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "budget-empty-avatar" };
const _hoisted_2 = ["src"];
const _hoisted_3 = {
    key: 1,
    class: "budget-main"
};
const _hoisted_4 = { class: "budget-text" };
const _hoisted_5 = { class: "budget-title" };
const _hoisted_6 = { class: "budget-meta" };
const _hoisted_7 = { class: "budget-meta-icon" };
const _hoisted_8 = ["src"];
const _hoisted_9 = { class: "budget-meta-date" };
const _hoisted_10 = { class: "budget-amounts" };
const _hoisted_11 = { class: "budget-current" };
const _hoisted_12 = { class: "budget-plan" };
const _hoisted_13 = ["src"];
export default /*@__PURE__*/ _defineComponent({
    __name: 'BudgetSummaryCard',
    props: {
        categoryName: {},
        currentSpend: {},
        planAmount: {},
        resetDate: {},
        inline: { type: Boolean },
        empty: { type: Boolean }
    },
    emits: ["click"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("a", {
                class: _normalizeClass(["budget-card", { 'budget-card-inline': _ctx.inline }]),
                onClick: _cache[0] || (_cache[0] = ($event) => (emit('click')))
            }, [
                (_ctx.empty)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("img", {
                                src: require('@/assets/budget-plan-icon.svg'),
                                alt: ""
                            }, null, 8, _hoisted_2)
                        ]),
                        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "budget-empty-title" }, "Set your budgets & plan", -1))
                    ], 64))
                    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("p", _hoisted_5, "Budget for " + _toDisplayString(_ctx.categoryName), 1),
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("img", {
                                        src: require('@/assets/refresh-cw.svg'),
                                        alt: ""
                                    }, null, 8, _hoisted_8)
                                ]),
                                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.resetDate), 1)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("span", _hoisted_11, "£" + _toDisplayString(Math.round(_ctx.currentSpend ?? 0)), 1),
                            _createElementVNode("span", _hoisted_12, "/£" + _toDisplayString(_ctx.planAmount), 1)
                        ])
                    ])),
                _createElementVNode("img", {
                    src: require('@/assets/arrow-right.png'),
                    class: "budget-arrow",
                    alt: ""
                }, null, 8, _hoisted_13)
            ], 2));
        };
    }
});
